module.exports = __webpack_public_path__ + "img/credit-one-club-inspiration-3.365ec191.jpg";